<ng-template>
  @if (icon) {
    <i class="bwi {{ icon }} !tw-me-2" aria-hidden="true"></i>
  }
  <ng-content></ng-content>
</ng-template>
